module.exports = __webpack_public_path__ + "img/rescue.426cf684.png";